import AsidePageMenu from '@cohort/merchants/components/AsidePageMenu';
import {InformationTootlip} from '@cohort/merchants/components/InformationTooltip';
import type FeatureFlags from '@cohort/merchants/featureFlags';
import {getCohortsRoute, getUsersRoute} from '@cohort/merchants/lib/Pages';
import {ListBullets, Users} from '@phosphor-icons/react';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {useTranslation} from 'react-i18next';

const UsersOverviewMenu = (): JSX.Element => {
  const {t} = useTranslation('pages', {keyPrefix: 'users.overview.usersOverviewMenu'});
  const {featureCohorts} = useFlags<FeatureFlags>();

  return (
    <AsidePageMenu
      entries={[
        {
          name: t('labelUsers'),
          path: getUsersRoute().path,
          icon: <Users size={20} />,
          testId: 'users-link',
        },
        {
          name: t('labelCohorts'),
          path: getCohortsRoute().path,
          icon: <ListBullets size={20} />,
          testId: 'cohort-link',
          disabled: !featureCohorts,
          addOn: !featureCohorts ? (
            <InformationTootlip
              className="ml-1 text-primary/20"
              side="bottom"
              content={
                <span className="flex rounded-xl bg-primary/10 px-3 py-1 text-sm font-medium leading-4 text-primary/80">
                  {t('comingSoon')}
                </span>
              }
            />
          ) : undefined,
        },
      ]}
    />
  );
};

export default UsersOverviewMenu;
